module.exports = __webpack_public_path__ + "img/img4.4e253d84.png";